import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { RecorderState } from './types';

export const useRecorderState = create<RecorderState>()(
  persist(
    (set) => ({
      isActive: false,
      tourStep: '',
      clusterId: '',
      recordedData: {},

      setIsActive: (isActive: boolean) => set({ isActive }),

      setTourStep: (tourStep: string) => set({ tourStep, recordedData: {} }),

      setClusterId: (clusterId: string) => set({ clusterId }),

      recordData: ({ feature, endpoint, record }) => {
        set((state) => ({
          recordedData: {
            ...state.recordedData,
            [feature]: {
              ...state.recordedData[feature],
              [endpoint]: record,
            },
          },
        }));
      },

      clearRecordedData: () => set({ recordedData: {} }),
    }),
    {
      name: 'op-tour-recorder',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isActive: state.isActive,
        tourStep: state.tourStep,
        clusterId: state.clusterId,
      }),
    }
  )
);

export const useIsRecordingDemoData = () =>
  useRecorderState((state) => state.isActive);
